Wee.fn.make('api', {
	/**
	 * Get request
	 * @param {object} options (optional)
	 */
	get: function(options) {
		this.$private.req($.extend({
			url: $.routes.uri().path
		}, options));
	},

	/**
	 * Post request
	 *
	 * @param {object} options (optional)
	 */
	post: function(options) {
		this.$private.req($.extend({
			method: 'post'
		}, options));
	}
}, {
	/**
	 * Fire fetch request
	 *
	 * @param {object} options (optional)
	 */
	req: function(options) {
		$.fetch.request($.extend({
			json: true
		}, options));
	}
});